<div class="mx-auto mt-10 flex w-fit flex-col rounded-md border border-border-3 bg-white px-24 py-14">
  <p class="text-sm">{{ 'onboarding.step-x-of-y' | translate: { x: 2, y: 3 } }}</p>
  <p class="my-4 text-xl leading-none">
    {{ 'onboarding.choose-how-your-size-chart-looks' | translate }}
  </p>
  <p class="text-[15px] leading-none text-text-2">
    {{ 'onboarding.select-the-category-that-best-matches-your-product' | translate }}
  </p>

  <div class="mt-10 flex flex-col gap-10">
    <button
      class="flex items-center gap-6 rounded-md border border-border-3 px-4 py-6 text-left transition-all hover:border-primary"
      [ngClass]="{ 'border-primary': selectedMethod() === 1 }"
      (click)="selectedMethod.set(1)"
    >
      <div class="shrink-0">
        <img
          src="/assets/product-chart.webp"
          class="w-[150px]"
          [alt]="'page.dashboard.create-from-product' | translate"
        />
      </div>

      <div class="flex grow flex-col gap-4">
        <p class="text-lg leading-none">{{ 'page.dashboard.create-from-product' | translate }}</p>

        <p class="text-[15px] leading-[24px] text-text-2">
          {{
            'onboarding.this-chart-connects-to-your-shopify-product-and-variants-so-shoppers-can-select-their-size-add-to-cart-or-buy-now-without-leaving-the-chart'
              | translate
          }}
        </p>
      </div>
    </button>

    <button
      class="flex items-center gap-6 rounded-md border border-border-3 px-4 py-6 text-left transition-all hover:border-primary"
      [ngClass]="{ 'border-primary': selectedMethod() === 0 }"
      (click)="selectedMethod.set(0)"
    >
      <div class="shrink-0">
        <img src="/assets/table-chart.webp" class="w-[150px]" [alt]="'onboarding.table-style-chart' | translate" />
      </div>

      <div class="flex grow flex-col gap-4">
        <div class="flex items-center justify-between">
          <p class="text-lg leading-none">{{ 'onboarding.table-style-chart' | translate }}</p>

          <div class="rounded-md bg-primary px-1.5 py-1 text-xs text-white">{{ 'common.recommend' | translate }}</div>
        </div>

        <p class="text-[15px] leading-[24px] text-text-2">
          {{
            'onboarding.create-a-grid-based-chart-with-rows-and-columns-best-for-detailed-size-specifications'
              | translate
          }}
        </p>
      </div>
    </button>

    @if (optionsExpanded()) {
      <mat-divider />

      <button
        class="flex items-center gap-6 rounded-md border border-border-3 px-4 py-6 text-left transition-all hover:border-primary"
        [ngClass]="{ 'border-primary': selectedMethod() === 2 }"
        (click)="selectedMethod.set(2)"
      >
        <div class="shrink-0">
          <img
            src="/assets/visual-chart.webp"
            class="w-[150px]"
            [alt]="'common.visual-measurement-builder' | translate"
          />
        </div>

        <div class="flex grow flex-col gap-4">
          <p class="text-lg leading-none">{{ 'common.visual-measurement-builder' | translate }}</p>
          <p class="text-[15px] leading-[24px] text-text-2">
            {{
              'onboarding.upload-any-product-image-and-place-measurements-visually-works-for-apparel-shoes-and-accessories'
                | translate
            }}
          </p>
        </div>
      </button>
    }
  </div>

  @if (!optionsExpanded()) {
    <button
      class="mt-6 flex w-fit items-center text-left text-[15px] leading-[24px] text-text-2 transition-all hover:text-primary"
      (click)="onExpandOptions()"
    >
      <span> {{ 'onboarding.other-ways-to-create-a-chart' | translate }} </span>
      <ng-icon name="featherChevronRight" />
    </button>
  }

  <div class="mt-10 flex gap-6">
    <button mat-button (click)="back.emit()">
      {{ 'common.back' | translate }}
    </button>
    <button mat-flat-button (click)="onContinue()" [disabled]="continueDisabled() || loading()">
      {{ (loading() ? 'common.creating...' : 'common.create') | translate }}
    </button>
  </div>
</div>
